import React from "react";
import useStyles from './styles';
import WarningIcon from '@material-ui/icons/Warning';

const WarningMessage = ({driverName, delay}) => {

    const classes = useStyles();

    return (
        <div className={classes.container} id={`warning-message-div`} data-cy={`warning-message-div`}>
            <div className={classes.body} id={`warning-message-body`} data-cy={`warning-message-body`}>
                <div className={classes.iconContainer} id={`warning-message-icon-container`} data-cy={`warning-message-icon-container`}>
                    <WarningIcon className={classes.icon} id={`warning-message-warning-icon`} data-cy={`warning-message-warning-icon`}/>
                </div>
                <div className={classes.mainMessage} id={`warning-message-text`} data-cy={`warning-message-text`}>
                Não foi possivel o contato com o <strong id={`warning-message-strong`} data-cy={`warning-message-strong`}>{driverName}</strong>,
                    dentro do prazo parametrizado na chamada ({delay} minutos)
                    as mensagens enviadas não chegaram ao celular de destino,
                        por algum dos motivos abaixo!
                </div>
                <div className={classes.note} id={`warning-message-text2`} data-cy={`warning-message-text2`}>
                O celular do motorista pode estar: Desligado, Sem bateria, sem sinal ou com numeração incorreta!
                </div>
            </div>
        </div>
    );
}

export default WarningMessage;
